/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { ICoverageDiscoveryResponseStateManager, ICLine, IOtherPayerAlertsSectionViewModels } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import './OtherPayerAlertSection.scss'
import { observer } from 'mobx-react'
import React from 'react'
import { injectProperty } from '../../../../arc/configuration/ServiceLocator'
import { ICoverageDiscoveryResponseApiClient } from '../../../../services/CoverageDiscoveryResponseApiClient/contracts'

export interface IOtherPayerAlertSectionProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}
interface IOtherPayerAlertSectionState {
	IsPageLoading: boolean
}

@observer
export class OtherPayerAlertSection extends React.Component<IOtherPayerAlertSectionProps, IOtherPayerAlertSectionState> {
	@injectProperty('ICoverageDiscoveryResponseApiClient')
	public readonly CoverageDiscoveryResponseApiClient!: ICoverageDiscoveryResponseApiClient

	constructor(props: Readonly<IOtherPayerAlertSectionProps>) {
		super(props)
		this.state = {
			IsPageLoading: true,
		}
	}
	componentDidMount(): void {
		this.setIsPageLoadState(false)
	}
	setIsPageLoadState(val: boolean): void {
		this.setState({
			IsPageLoading: val,
		})
	}
	renderOtherPayerAlertSection(otherPayerAlertSectionViewModels: IOtherPayerAlertsSectionViewModels[]): any {
		return <tbody>{this.renderOtherPayerAlertData(otherPayerAlertSectionViewModels)}</tbody>
	}

	renderOtherPayerAlertData(otherPayerAlertSectionViewModels: IOtherPayerAlertsSectionViewModels[]): any {
		let lines: Array<ICLine> = []
		if (typeof otherPayerAlertSectionViewModels !== 'undefined')
			return otherPayerAlertSectionViewModels.map(eligibilityBenefit => {
				lines = eligibilityBenefit.cLineList
				if (lines.length > 0) {
					return lines.map((line, index) => {
						const rowClass = index + 1 === lines.length ? 'bottom-border-td' : ''
						let first = ''
						let second = ''
						for (let i = 0; i < line.sections.length; i++) {
							if (i === 0) {
								first = line.sections[i].value + ':'
							} else {
								second += line.sections[i].value
							}
						}
						index++
						return (
							<tr key={index}>
								<td className={rowClass}>{first}</td>
								<td className={rowClass} colSpan={3}>
									<span>{second}</span>
								</td>
							</tr>
						)
					})
				}
				return <></>
			})
	}

	render(): JSX.Element {
		const otherPayerAlertSection = this.props.CoverageDiscoveryResponseStateManager.selectedOtherPayerAlert
		if (otherPayerAlertSection && otherPayerAlertSection.otherPayersSectionViewModels && otherPayerAlertSection.otherPayersSectionViewModels.length !== 0) {
			return (
				<div className="cdResponsePage">
					<table className="service-types-table status-alert">
						<thead>
							<tr className="Other-Payer-Alert-header1">
								<td colSpan={4} style={{ paddingLeft: '10px' }}>
									<h4>Other Payer Alert</h4>
								</td>
							</tr>
						</thead>
						{this.renderOtherPayerAlertSection(otherPayerAlertSection.otherPayersSectionViewModels)}
					</table>
				</div>
			)
		} else {
			return <></>
		}
	}
}
